module.exports = __webpack_public_path__ + "img/3-3-1.2f7e06a8.gif";